import * as GroupType from 'constants/GroupType';

const BIATHLON_GROUP_MAP = {};

BIATHLON_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
BIATHLON_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
BIATHLON_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
BIATHLON_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
BIATHLON_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
BIATHLON_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;
BIATHLON_GROUP_MAP[6] = GroupType.SIXTH_PERIOD_GROUP;
BIATHLON_GROUP_MAP[7] = GroupType.SEVENTH_PERIOD_GROUP;
BIATHLON_GROUP_MAP[8] = GroupType.EIGHTH_PERIOD_GROUP;

export default BIATHLON_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Biathlon/GroupMap.js